import View from './CodeScanner.jsx'
import container from './container.js'

const CodeScanner = container(View)
CodeScanner.displayName = 'CodeScanner'

export default CodeScanner
